import { APP_ROUTES, apiErrorParser, useAppSelector, useAppTranslation } from "@/utils";
import { bnplConsumerApis } from "@payping/api";
import { CloseCircleFilled, PhRArrowCounterClockwise } from "@payping/icons";
import { Button, Flex, Typography, useMessagedAsyncFn } from "@payping/web-components";
import { Link } from "react-router";

const PrePayCallbackFailedPaymentPage = () => {
  const { t } = useAppTranslation();

  const trackingCode = useAppSelector((state) => state.dashboardPersist.trackingCode);

  const [prePayState, prePay] = useMessagedAsyncFn(
    async (tc: string) => {
      try {
        const res = await bnplConsumerApis.prePaymentPay({
          trackingCode: tc,
        });
        if (res.url) {
          window.location.replace(res.url);
        }

        return res;
      } catch (error: any) {
        const parsedError = await apiErrorParser(error);
        if (parsedError.parsed) {
          throw parsedError.parsed;
        }
        throw parsedError.original;
      }
    },
    [],
    { loading: false },
    { error: true },
  );

  const handleClickPrePay = async () => {
    await prePay(trackingCode);
  };

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!" gap={"middle"} align="center" justify="center">
      <Flex vertical align="center" justify="center" gap={"large"} className="tw:my-auto tw:w-full">
        <CloseCircleFilled width={80} className="tw:fill-color-error" />
        <Flex vertical gap={"small"} align="center" justify="center">
          <Typography.Title level={5} className="tw:m-0! tw:font-semibold!">
            {t("pay.getOrder.steps.payPromissory.paymentRejectTitle")}
          </Typography.Title>
          <Typography.Text type="secondary" className="tw:text-center">
            {t("pay.getOrder.steps.payPromissory.paymentRejectContent")}
          </Typography.Text>
        </Flex>
        <Button
          icon={<PhRArrowCounterClockwise width={14} height={14} />}
          onClick={async () => {
            await handleClickPrePay();
          }}
          type="link"
          loading={prePayState.loading}
        >
          {t("common.retry")}
        </Button>
      </Flex>

      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Link className="tw:w-full" to={APP_ROUTES.home.overview.url}>
          <Button block disabled={prePayState.loading}>
            {t("common.returnToHome")}
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
};

export default PrePayCallbackFailedPaymentPage;
